<ion-content>
  <ion-scroll zooming="true" direction="xy" style="height:500px">
    <div class="allpageview">

      <div class="race-info-modal modal-dialog modal-lg modal-dialog-centered">

        <!-- <div class="modal-content">
          <div class="modal-header">
            <button (click)="dismiss()" type="link" class="close">
              <span class="icon icon-close"></span>
            </button>

            <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
              <div class="racer-avatar">

                <img [src]="(isjerseyIconShown == 'Y' || jerseyIcon == 'NA')? frontPath : backPath">

                <span class="counter">{{value.shirtNumber}}</span>
              </div>
              <div class="name">{{value.name}}</div>
            </div>
            <div class="description">
              <span class="text">Age <strong>{{value.age_years}}</strong>
              </span>
              <span class="text">Weight <strong>{{value.weight_value}}</strong>
              </span>
              <span class="text">Horse Form <strong>{{value.horse_form}}</strong>
              </span>
              <span class="text">Jockey <strong>{{value.horse_jockey_name}}</strong>
              </span>
              <span class="text">Owner <strong>{{value.owner_name}}</strong>
              </span>
              <span class="text">Trainer <strong>{{value.trainer_name}}</strong>
              </span>
            </div>
          </div>

          <div class="modal-body">
            <h4 class="text-center">Horse Form</h4>
            <div class="quick-stats">
              <div class="stats" style="margin-left: 0px;">
                <span class="large">{{value.horse_status_runs}}</span>
                <span class="text">Runs</span>
              </div>
              <div class="stats">
                <span class="large">{{value.horse_status_wins}}</span>
                <span class="text">Wins</span>
              </div>
              <div class="stats">
                <span class="large">{{value.horse_status_places}}</span>
                <span class="text">Places</span>
              </div>
              <div class="stats">
                <span class="large">${{value.horse_status_prizemoney}}</span>
                <span class="text">Prize</span>
              </div>
            </div>
            <div class="runner-comments">
              <h4 style="padding: 0px;margin-top: 0px;">
                <span class="icon icon-comment"></span>Runner Comments</h4>
              <p>
                {{value.runner_commments}}
              </p>
            </div>
          </div>

        </div> -->




        <!-- if  Country AU and sport DG -->
        <div class="modal-content">

          <div *ngIf="(selectionData | json)!='{}' && oddData.countryCode=='AU' && oddData.sportCategoryId=='DG' ">

            <div class="modal-header">

              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>

              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">

                  <!-- <img src="../../../assets/icon/default-jersey.png"> -->
                  <img [src]="oddData.jerseyIcon != 'NA' && oddData.showJersey=='Y' ? 'data:image/gif;base64,' + oddData.jerseyIcon : '../../../../assets/icon/default-greyHound.png'  ">

                  <span class="counter">{{oddData.selectionNumber}}</span>
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>

              <div class="description">
                <span class="text">No: <strong>{{selectionData.DogNo}}</strong>
                </span>
                <span class="text">Name: <strong>{{selectionData.DogName}}</strong>
                </span>
                <span class="text">Trainer: <strong>{{selectionData.DogTrainer}}</strong>
                </span>
                <span class="text">Owners: <strong>{{selectionData.DogOwners}}</strong>
                </span>
                <span class="text">Grade: <strong>{{selectionData.DogGrade}}</strong>
                </span>
                <span class="text">Earnings: <strong>{{selectionData.DogEarnings}}</strong>
                </span>
                <span class="text">CareerStarts: <strong>{{selectionData.DogCareerStarts}}</strong>
                </span>
                <span class="text">CareerWins: <strong>{{selectionData.DogCareerWins}}</strong>
                </span>
                <span class="text">CareerSeconds: <strong>{{selectionData.DogCareerSeconds}}</strong>
                </span>
                <span class="text">CareerThirds: <strong>{{selectionData.DogCareerThirds}}</strong>
                </span>
                <span class="text">Price: <strong>{{selectionData.DogPrice}}</strong>
                </span>
                <span class="text">Last3Starts: <strong>{{selectionData.DogLast3Starts}}</strong>
                </span>
                <span class="text">Best: <strong>{{selectionData.DogBest}}</strong>
                </span>
              </div>
            </div>
            <div class="modal-body">

            </div>
          </div>






          <div *ngIf="(selectionData | json)!='{}' && oddData.countryCode=='AU' && oddData.sportCategoryId=='HA' ">

            <div class="modal-header">
              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>

              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">

                  <img src="../../../assets/icon/default-jersey.png">

                  <span class="counter">{{oddData.selectionNumber}}</span>
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>

              <div class="description">
                <span class="text">Number: <strong>{{selectionData.Number}}</strong>
                </span>
                <span class="text">Name: <strong>{{selectionData.Name}}</strong>
                </span>
                <span class="text">Handicap: <strong>{{selectionData.Handicap}}</strong>
                </span>
                <span class="text">Driver: <strong>{{selectionData.Driver}}</strong>
                </span>
                <span class="text">Trainer: <strong>{{selectionData.Trainer}}</strong>
                </span>
                <span class="text">Previous Runs: <strong>{{selectionData.Previous_Runs}}</strong>
                </span>
                <span class="text">Career Starts: <strong>{{selectionData.Career_Starts}}</strong>
                </span>
                <span class="text">Age: <strong>{{selectionData.Age}}</strong>
                </span>
                <span class="text">Strike Rate: <strong>{{selectionData.Strike_Rate}}</strong>
                </span>
                <span class="text">Rating: <strong>{{selectionData.Rating}}</strong>
                </span>
                <span class="text">Form 1: <strong>{{selectionData.Form1}}</strong>
                </span>
                <span class="text">Form 2: <strong>{{selectionData.Form2}}</strong>
                </span>

              </div>
            </div>
            <div class="modal-body">

            </div>
          </div>








          <div *ngIf="(selectionData | json)!='{}' && oddData.countryCode=='AU' && oddData.sportCategoryId=='HR' ">

            <div class="modal-header">
              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>

              <!-- <img [src]="(isjerseyIconShown == 'Y' || jerseyIcon == 'NA')? frontPath : backPath"> -->

              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">

                  <img src="../../../assets/icon/default-jersey.png">

                  <span class="counter">{{oddData.selectionNumber}}</span>
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>

              <div class="description">
                <span class="text">Barrier: <strong>{{selectionData.Barrier}}</strong>
                </span>
                <span class="text">Jockey: <strong>{{selectionData.Jockey}}</strong>
                </span>
                <span class="text">Trainer: <strong>{{selectionData.Trainer}}</strong>
                </span>
                <span class="text">Age: <strong>{{selectionData.Age}}</strong>
                </span>
                <span class="text">Owners: <strong>{{selectionData.Owners}}</strong>
                </span>
                <span class="text">Career Earnings: <strong>{{selectionData.Career_Earnings}}</strong>
                </span>
                <span class="text">Career Starts: <strong>{{selectionData.Career_Starts}}</strong>
                </span>
                <span class="text">Form 1: <strong>{{selectionData.Form1}}</strong>
                </span>
                <span class="text">Form 2: <strong>{{selectionData.Form2}}</strong>
                </span>
                <span class="text">Form 3: <strong>{{selectionData.Form3}}</strong>
                </span>
                <span class="text">Form 4: <strong>{{selectionData.Form4}}</strong>
                </span>
              </div>
            </div>
            <div class="modal-body">

            </div>

          </div>






          <div *ngIf="(selectionData | json)!='{}' && oddData.sportCategoryId=='HR' && 
          (oddData.countryCode == 'UK' ||
          oddData.countryCode == 'FR' ||
          oddData.countryCode == 'CL' ||
          oddData.countryCode == 'UY' ||
          oddData.countryCode == 'AE' ||
          oddData.countryCode == 'AR' ||
          oddData.countryCode == 'BR' ||
          oddData.countryCode == 'DEU' ||
          oddData.countryCode == 'ES' ||
          oddData.countryCode == 'FR' ||
          oddData.countryCode == 'HK' ||
          oddData.countryCode == 'IE' ||
          oddData.countryCode == 'KR' ||
          oddData.countryCode == 'MU' ||
          oddData.countryCode == 'MX' ||
          oddData.countryCode == 'OT' ||
          oddData.countryCode == 'PE' ||
          oddData.countryCode == 'SA' ||
          oddData.countryCode == 'SG' ||
          oddData.countryCode == 'US' ||
          oddData.countryCode == 'WO' ||
          oddData.countryCode == 'ZA' ||
          oddData.countryCode == 'CA' ||
          oddData.countryCode == 'IN'
          ) ">


            <div class="modal-header">
              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>

              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">

                  <!-- <img [src]="(isjerseyIconShown == 'Y' || jerseyIcon == 'NA')? frontPath : backPath"> -->
                  <!-- <img [src]="'data:image/gif;base64,'+oddData.jerseyIcon"> -->
                  <img [src]="oddData.jerseyIcon != 'NA' && oddData.showJersey=='Y' ? 'data:image/gif;base64,' + oddData.jerseyIcon : '../../../../assets/icon/default-jersey.png'  ">
                  

                  <!-- <span class="counter">{{selectionData.Number}}</span> -->
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>

              <div class="description">
                <span class="text">Age: <strong>{{selectionData.age_years}}</strong>
                </span>
                <span class="text">Weight: <strong>{{selectionData.weight_text}}</strong>
                </span>
                <span class="text">Jockey: <strong>{{selectionData.horse_jockey_name}}</strong>
                </span>
                <span class="text">Owner: <strong>{{selectionData.owner_name}}</strong>
                </span>
                <span class="text" >Horse Form: <strong style="letter-spacing: 6px;">{{selectionData.formfigures_figures.substr(selectionData.formfigures_figures.length - 4)}}</strong>
                </span>
                <span class="text">Trainer: <strong>{{selectionData.trainer_name}}</strong>
                </span>

              </div>
            </div>
            <div class="modal-body">
              <div class="quick-stats">
                <div class="stats" style="margin-left: 0px;">
                  <span class="large text-black">{{selectionData.horse_status_runs}}</span>
                  <span class="text text-black">Runs</span>
                </div>
                <div class="stats">
                  <span class="large text-black">{{selectionData.horse_status_wins}}</span>
                  <span class="text text-black">Wins</span>
                </div>
                <div class="stats">
                  <span class="large text-black">{{selectionData.horse_status_places}}</span>
                  <span class="text text-black">Places</span>
                </div>
                <div class="stats">
                  <span class="large" style="display: inline-block;">
                    <div style="font-size: 15px !important; display: inline-block;color: black;">
                      GBP
                    </div>
                    <div style="margin-top: 10px;color: black;">
                      {{selectionData.horse_status_prizemoney}}
                    </div>
                     
                  </span>
                  <span class="text text-black">Prize Money</span>
                </div>
              </div>

              <table class="racing-table  table-striped">
                <thead>
                  <tr>
                    <th>Placing</th>
                    <th>Distance (Furlongs)</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let row of selectionData.runHistory;let i = index" class="won">
                    <td>{{row.place}}</td>
                    <td>{{row.furlongs}}</td>
                    <td>{{row.date}}</td>
                  </tr>

                </tbody>
              </table><br>

              <div class="runner-comments">
                <h4 style="padding: 0px;margin-top: 0px;color: black;">
                  <span class="icon icon-comment"></span>Runner Comments
                </h4>
                <p class="text-black">
                  {{selectionData.runner_commments}}
                </p>
              </div>

            </div>

          </div>









          <div *ngIf="(selectionData | json)!='{}' && oddData.countryCode=='UK' && oddData.sportCategoryId=='DG' ">

            <div class="modal-header">
              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>
  
              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">
  
                  <!-- <img src="../../../assets/icon/default-jersey.png"> -->
                  <img [src]="oddData.jerseyIcon != 'NA' && oddData.showJersey=='Y' ? 'data:image/gif;base64,' + oddData.jerseyIcon : '../../../../assets/icon/default-greyHound.png'  ">
  
                  <span class="counter">{{oddData.selectionNumber}}</span>
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>
  
              <div class="description">
                <span class="text text-black">Best Time: <strong>{{selectionData.best_time_adjustedTime}}</strong>
                </span>
                <span class="text text-black">Trainer: <strong>{{selectionData.trainer}}</strong>
                </span>
                <span class="text text-black">Owner: <strong>{{selectionData.owner}}</strong>
                </span>
              </div>
            </div>
  
            <div class="modal-body">
  
              <div class="item" *ngFor="let item of selectionData.formRaceList">
                <div class="description">
                  <span class="text text-black">Date: <b>{{item.date}}</b>
                  </span><br>
                  <span class="text text-black">Track: <b>{{item.track}}</b>
                  </span><br>
                  <span class="text text-black">Time: <b>{{item.time}}</b>
                  </span>
                </div>
  
                <table class="racing-table  table-striped">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Result</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
  
                    <tr *ngFor="let row of item.formTrapList" class="won">
                      <td>{{row.dogName}}</td>
                      <td>{{row.resultPosn}}</td>
                      <td>{{row.price}}</td>
                    </tr>
  
                  </tbody>
                </table>
                <br><br>
              </div>
            </div>

          </div>











          <div *ngIf="(selectionData | json)=='{}'">

            <div class="modal-header">
              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>
  
              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">
                  
                  <img *ngIf="oddData.sportCategoryId=='DG'" [src]="oddData.jerseyIcon != 'NA' && oddData.showJersey=='Y' ? 'data:image/gif;base64,' + oddData.jerseyIcon : '../../../../assets/icon/default-greyHound.png'  ">
                  <img *ngIf="oddData.sportCategoryId!='DG'" [src]="oddData.jerseyIcon != 'NA' && oddData.showJersey=='Y' ? 'data:image/gif;base64,' + oddData.jerseyIcon : '../../../../assets/icon/default-jersey.png'  ">
                  
  
                  <span class="counter">{{oddData.selectionNumber}}</span>
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>
  
              <div class="description">
                <br><br>
                <!-- <p style="text-align: center; font-size: 22px;margin: 0 auto;">No Selection Info for this event Selection
                </p> --> <br> <br>
              </div>
            </div>
            <div class="modal-body">
  
            </div>

          </div>


          <div *ngIf="(selectionData | json) !=='{}' && oddData.countryCode=='VR'">

            <div class="modal-header">
              <button (click)="dismiss()" type="link" class="close">
                <span class="icon icon-close"></span>
              </button>
  
              <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
                <div class="racer-avatar">
  
                  <!-- <img src="../../../assets/icon/default-jersey.png"> -->
                  <img [src]="oddData.jerseyIcon != 'NA' && oddData.showJersey=='Y' ? 'data:image/gif;base64,' + oddData.jerseyIcon : '../../../../assets/icon/default-jersey.png'  ">
  
                  <span class="counter">{{oddData.selectionNumber}}</span>
                </div>
                <div class="name">{{oddData.name}}</div>
              </div>

            </div>
  
            <div class="modal-body">
              <div *ngIf="oddData.sportCategoryId=='HR'">
                <span class="text text-black">Jockey: <strong>{{selectionData.jockey}}</strong>
                </span>
                <br>
                <span class="text text-black">Horse Form: <strong>{{selectionData.FormFigures}}</strong>
                </span>
              </div>
              <div *ngIf="oddData.sportCategoryId=='DG'">
                <span class="text text-black">Greyhound form: <strong>{{selectionData.FormFigures}}</strong>
                </span>
              </div>
              
      
            </div>

          </div>






        </div>











      </div>
    </div>














    <!-- <div class="allpageview" *ngIf = "isSportType == 'UKGreyhound'">

      <div class="race-info-modal modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button (click)="dismiss()" type="link" class="close">
              <span class="icon icon-close"></span>
            </button>
            <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;">
              <div class="racer-avatar">

                <img [src]="(isjerseyIconShown == 'Y' || jerseyIcon == 'NA')? frontPath : backPath">

                <span class="counter">{{value.shirtNumber}}</span>
              </div>
              <div class="name">{{value.name}}</div>
            </div>
            <div class="description">
              <span class="text">Best Time : <strong>{{value.age_years}}</strong>
              </span>
              <span class="text">Trainer :  <strong>{{value.weight_value}}</strong>
              </span>
              <span class="text">Owner :  <strong>{{value.horse_form}}</strong>
              </span>
              <span class="text">Form Race :  <strong>{{value.horse_jockey_name}}</strong>
              </span>
              
            </div>
          </div>
          
        </div>
      </div>
    </div> -->























  </ion-scroll>

</ion-content>